<app-editor-loading-screen *ngIf="loading"></app-editor-loading-screen>
<h3 class="primary-color" mat-dialog-title>{{data.title}}</h3>
<div mat-dialog-content>
	{{data.description}}
	<div class="form-group kt-form__group" style="overflow-y: auto;
			max-height: 50vh;">
		<div class="form-group flex flex-row gap-[20px]">
			<div class="flex flex-1 mb-10">
				<img *ngIf="returnData['imageUrl']" style="height: 150px;" src="{{returnData['imageUrl']}}" />
				<img *ngIf="!returnData['imageUrl']" style="height: 150px;"
					src="./assets/images/error-default-image-new.png" />
			</div>
			<div class="flex flex-1">
				<input style="display: none" accept="image/*" type="file" (change)="onFileChanged($event)"
					#fileImageInput accept="{{allowedAcceptExtensions}}">
				<button mat-icon-button (click)="fileImageInput.click()" title="Upload new image">
					<mat-icon>upload_2</mat-icon>
				</button>&nbsp;
				<button *ngIf="returnData['imageUrl']" mat-icon-button (click)="returnData['imageUrl'] = ''"
					title="Clear selected image" [disabled]="loading" [disabled]="loading">
					<mat-icon>remove</mat-icon>
				</button>
			</div>
		</div>
		<div class="form-group flex flex-row gap-[10px]">
			<div class="flex flex-1">
				<mat-form-field class="w-full">
					<mat-label>{{ "Width" }}</mat-label>
					<input matInput [(ngModel)]="returnData.width" placeholder="Width">
				</mat-form-field>
			</div>
			<div class="flex flex-1">
				<mat-form-field class="w-full">
					<mat-label>{{ "Height" }}</mat-label>
					<input matInput [(ngModel)]="returnData.height" placeholder="Height">
				</mat-form-field>
			</div>
		</div>
		<div class="form-group kt-form__group row">
			<div class="col col-lg-12">
				<mat-form-field class="example-full-width w-full">
					<mat-label>{{ "Target Url" }}</mat-label>
					<input matInput [(ngModel)]="returnData.targetUrl" placeholder="Target Url">
				</mat-form-field>
			</div>
		</div>
		<div class="form-group kt-form__group row">
			<div class="col col-lg-12">
				<mat-form-field class="w-full">
					<mat-label>Select Target</mat-label>
					<mat-select [(value)]="returnData.target" [disabled]="returnData.targetUrl === ''">
						<mat-option *ngFor="let target of anchorTargets" [value]="target.value">
							{{ target.display }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
		</div>
	</div>
</div>
<div mat-dialog-actions align="end">
	<button mat-button (click)="onNoClick()" color="danger">{{data.cancelbtn}}</button>&nbsp;
	<button mat-raised-button (click)="onYesClick()" cdkFocusInitial [disabled]="loading">{{data.confirmbtn}}</button>
</div>